<template lang='pug'>
v-datetime-picker(
  clearText="Отменить",
  okText="Ок",
  :label="label",
  :textFieldProps="{ filled: true, 'hide-details': 'auto', 'prepend-inner-icon': 'mdi-calendar-today' }",
  :timePickerProps="{ format: '24hr' }",
  :datetime="value",
  @input="$emit('input', $event)",
  v-bind="$props"
)
  template(slot="dateIcon")
    v-icon mdi-calendar-blank
  template(slot="timeIcon")
    v-icon mdi-alarm
</template>

<script>
export default {
  props: {
    value: {
      type:Date,
      default() {
        return new Date();
      },
    },
    label:{ type:String, default:'Дата' },
  },
  // updated() {
  //   console.log(this.value);
  // },
};
</script>

<style lang='scss'>
</style>
